import axios from "axios";

/**
 * @description Get logged in data from API /api/auth/is-logged-in
 * 
 * @emits "nosubscription" if user has no subscription
 * @emits "apierror" if something went wrong
 * 
 * @param {Function} callbackFunction 
 * @param {Function} error_callback_function 
 */
function APIIsLoggedIn( callbackFunction, error_callback_function ) {

	let hostname = window.location.hostname;
	let protocol = window.location.protocol;
	let api_url = protocol + "//api." + hostname + "/api/auth/is-logged-in";

	axios.post(
		api_url,
		null,
		{
			withCredentials: true
		}
	)
	     .then( response => {
			var status = response.data.status;
			var data = response.data.data; 

            // Set responce data to window.UserProfile
			if( status == 1 && data !== false ) {
				window.UserProfile.is_logged_in = true;
				window.UserProfile.user_id = response.data.userId;
				window.UserProfile.role = response.data.role;
				window.UserProfile.country = response.data.country;

				// Run Callback Function
				if ( 'function' == typeof callbackFunction ) {
					callbackFunction();
				}

			} else {
				if ( 'function' == typeof error_callback_function ) {
					window.UserProfile.is_logged_in = false;
					const nosubscription = new CustomEvent( "nosubscription" );
					document.dispatchEvent( nosubscription );
					const api_error = new CustomEvent( "apierror" );
					document.dispatchEvent( api_error );
					
					error_callback_function();
				}
			}

			if ( response.data.hasOwnProperty( "userId" ) ) {
				Cookie.setCookie( "userId", response.data.userId, { path: "/" } );
				Cookie.setCookie( "userCountry", response.data.country, { path: "/" } );
			} else {
				Cookie.deleteCookie( "userId" );
				Cookie.deleteCookie( "userCountry" );
			}
	     } )
	     .catch( ( error ) => {
			Cookie.deleteCookie( "userId" );
			Cookie.deleteCookie( "userCountry" );
			const nosubscription = new CustomEvent( "nosubscription" );
			document.dispatchEvent( nosubscription );
			const api_error = new CustomEvent( "apierror" );
			document.dispatchEvent( api_error );
		     console.error( error );
	     } );
}

export { APIIsLoggedIn };
